const dataScienceProjects = [
  {
    id: "sales-forecasting",
    title: "AI Sales Forecasting System",
    category: "Data Science",
    domain: "Business Analytics",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Predict future sales using historical business data and machine learning models.",
    description:
      "Build a sales forecasting platform that analyzes historical sales patterns and generates future sales predictions with visual analytics.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "React",
      "MongoDB",
    ],
    skills: [
      "Data Analysis",
      "Time Series",
      "Machine Learning",
      "Data Visualization",
      "Python",
    ],
    features: [
      "Sales data upload",
      "Data preprocessing",
      "Forecast generation",
      "Interactive charts",
      "Sales analytics",
      "Prediction history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "customer-churn-analysis",
    title: "Customer Churn Prediction & Analytics",
    category: "Data Science",
    domain: "Business Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2999",
    shortDescription:
      "Identify customers likely to leave a business using machine learning and analytics.",
    description:
      "Develop a customer analytics platform that predicts churn probability and identifies important factors affecting customer retention.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "React",
      "MongoDB",
    ],
    skills: [
      "Classification",
      "EDA",
      "Feature Engineering",
      "Machine Learning",
      "Data Visualization",
    ],
    features: [
      "Customer data upload",
      "Churn prediction",
      "Risk classification",
      "Customer analytics",
      "Charts and reports",
      "Prediction history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "student-performance-analysis",
    title: "Student Performance Prediction",
    category: "Data Science",
    domain: "Education Analytics",
    difficulty: "Beginner",
    duration: "5-6 Weeks",
    price: "₹1999",
    shortDescription:
      "Analyze academic data and predict student performance using machine learning.",
    description:
      "Build an education analytics system that studies attendance, previous marks, study habits and other factors to predict student performance.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "Matplotlib",
      "React",
    ],
    skills: [
      "Data Analysis",
      "Regression",
      "Classification",
      "EDA",
      "Visualization",
    ],
    features: [
      "Student data management",
      "Performance prediction",
      "Risk identification",
      "Academic analytics",
      "Charts",
      "Reports",
    ],
    suitableFor: ["BCA", "MCA", "BSc CS"],
  },
  {
    id: "real-estate-price-analysis",
    title: "Real Estate Price Prediction",
    category: "Data Science",
    domain: "Real Estate Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2499",
    shortDescription:
      "Predict property prices using location, area, amenities and historical market data.",
    description:
      "Create a machine learning application that estimates property prices based on important real estate features.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "React",
      "MongoDB",
    ],
    skills: [
      "Regression",
      "Data Cleaning",
      "Feature Engineering",
      "EDA",
      "Visualization",
    ],
    features: [
      "Property data",
      "Price prediction",
      "Location analysis",
      "Price comparison",
      "Interactive charts",
      "Prediction history",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech", "BE"],
  },
  {
    id: "loan-risk-analysis",
    title: "Loan Risk Prediction & Analytics",
    category: "Data Science",
    domain: "Financial Analytics",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Analyze applicant information and estimate loan approval or risk using machine learning.",
    description:
      "Develop a financial analytics application that processes applicant information and predicts loan approval or risk categories.",
    technologies: [
      "Python",
      "Pandas",
      "Scikit-learn",
      "NumPy",
      "React",
      "MongoDB",
    ],
    skills: [
      "Classification",
      "Data Preprocessing",
      "Feature Engineering",
      "Model Evaluation",
      "Data Analysis",
    ],
    features: [
      "Applicant data",
      "Risk prediction",
      "Approval prediction",
      "Analytics dashboard",
      "Model evaluation",
      "Reports",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "healthcare-data-analysis",
    title: "Healthcare Data Analytics System",
    category: "Data Science",
    domain: "Healthcare Analytics",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3499",
    shortDescription:
      "Analyze healthcare datasets and generate meaningful insights using data science.",
    description:
      "Build an academic healthcare analytics platform that explores patient datasets, identifies patterns and generates predictive insights.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "Matplotlib",
      "React",
    ],
    skills: [
      "Data Analysis",
      "EDA",
      "Machine Learning",
      "Data Visualization",
      "Statistical Analysis",
    ],
    features: [
      "Dataset upload",
      "Data cleaning",
      "Patient analytics",
      "Prediction models",
      "Charts",
      "Reports",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "employee-attrition-analysis",
    title: "Employee Attrition Prediction",
    category: "Data Science",
    domain: "HR Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2499",
    shortDescription:
      "Predict employee attrition and discover important factors affecting employee retention.",
    description:
      "Develop an HR analytics system that predicts employee attrition and provides insights into factors influencing workforce retention.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "React",
      "MongoDB",
    ],
    skills: [
      "Classification",
      "EDA",
      "HR Analytics",
      "Feature Engineering",
      "Visualization",
    ],
    features: [
      "Employee dataset",
      "Attrition prediction",
      "Risk analysis",
      "HR dashboard",
      "Charts",
      "Reports",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },
  {
    id: "stock-market-analysis",
    title: "Stock Market Data Analysis",
    category: "Data Science",
    domain: "Financial Analytics",
    difficulty: "Advanced",
    duration: "8-10 Weeks",
    price: "₹3999",
    shortDescription:
      "Analyze historical stock market data and visualize trends using data science techniques.",
    description:
      "Create a financial analytics platform for exploring historical market data, calculating indicators and visualizing price trends.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "Scikit-learn",
      "React",
    ],
    skills: [
      "Time Series",
      "Data Analysis",
      "Financial Analytics",
      "Visualization",
      "Feature Engineering",
    ],
    features: [
      "Historical price analysis",
      "Market charts",
      "Technical indicators",
      "Trend analysis",
      "Dataset management",
      "Analytics dashboard",
    ],
    suitableFor: ["MCA", "B.Tech", "BE", "MSc CS"],
  },
  {
    id: "retail-sales-analysis",
    title: "Retail Sales Analytics Dashboard",
    category: "Data Science",
    domain: "Retail Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2499",
    shortDescription:
      "Analyze retail sales data to identify trends, top products and business performance.",
    description:
      "Build a retail analytics dashboard that transforms sales datasets into actionable business insights through charts and KPIs.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Matplotlib",
      "React",
      "MongoDB",
    ],
    skills: [
      "EDA",
      "Business Analytics",
      "Data Visualization",
      "Python",
      "Dashboard Development",
    ],
    features: [
      "Sales dashboard",
      "Product analysis",
      "Revenue analysis",
      "Customer analysis",
      "Interactive charts",
      "KPI reports",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },
  {
    id: "weather-data-analysis",
    title: "Weather Data Analytics & Prediction",
    category: "Data Science",
    domain: "Environmental Analytics",
    difficulty: "Intermediate",
    duration: "6-8 Weeks",
    price: "₹2499",
    shortDescription:
      "Analyze historical weather data and build predictive models for selected weather parameters.",
    description:
      "Develop a weather analytics application that processes historical datasets, identifies patterns and generates predictions using machine learning.",
    technologies: [
      "Python",
      "Pandas",
      "NumPy",
      "Scikit-learn",
      "Matplotlib",
      "React",
    ],
    skills: [
      "Time Series",
      "Data Analysis",
      "Regression",
      "Visualization",
      "Machine Learning",
    ],
    features: [
      "Weather dataset",
      "Trend analysis",
      "Prediction",
      "Interactive charts",
      "Historical comparison",
      "Reports",
    ],
    suitableFor: ["BCA", "MCA", "B.Tech"],
  },
];

export default dataScienceProjects;